export default __webpack_public_path__ + "static/radar-icon-41eb5565a3a3124ec3a8c9e286e3832e.png";